import React from 'react';
import "./../Components/Other_Components/ContestLoader.css";

function ContestLoader() {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/10">
            <div className="dot-spinnerr">
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
                <div className="dot-spinnerr__dot"></div>
            </div>
        </div>
    );
}

export default ContestLoader;
